import { useTheme } from "@/context/ThemeContext";
import { useLang } from "@/context/LangContext";
import { Sun, Moon } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export const ThemeToggle = ({ className = "" }) => {
  const { theme, toggle } = useTheme();
  const { tc } = useLang();
  const isDark = theme === "dark";
  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label={tc({ id: "Ganti mode gelap/terang", en: "Toggle dark mode", ar: "تبديل الوضع الليلي" })}
      className={`relative flex h-10 w-10 items-center justify-center rounded-full border border-border/60 bg-card/70 text-foreground transition-colors hover:bg-accent ${className}`}
    >
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={isDark ? "moon" : "sun"}
          initial={{ rotate: -90, opacity: 0, scale: 0.6 }}
          animate={{ rotate: 0, opacity: 1, scale: 1 }}
          exit={{ rotate: 90, opacity: 0, scale: 0.6 }}
          transition={{ duration: 0.2 }}
        >
          {isDark ? <Moon className="h-5 w-5 text-gold" /> : <Sun className="h-5 w-5 text-primary" />}
        </motion.span>
      </AnimatePresence>
    </button>
  );
};
